import { Link } from "@StarberryUtils";
import React, { useState, useEffect } from "react"
import { Container, Row, Col } from 'react-bootstrap';
// import img01 from "../../../images/home/review_img.jpg"

import feefologo from "../../../images/feefo-logo-dark.svg"
import { feefo, allFeefo } from "../../Common/site/functions";
// import { GetURL, lazyLoader } from "../../Common/site/functions";
import _ from "lodash";
import moment from "moment/src/moment";
import ReactReadMoreReadLess from "react-read-more-read-less";
import "./Reviews.scss"

import { inViewOptions, easeFunc, containerVariants, fadeInFromRight } from '../../Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const contentItemText = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            ...easeFunc,
            duration: 1.2
        }
    }
}

// markup
const Foundation = (props) => {
    const [reviews, setReviews] = useState(null);
    const [avgReview, setAvgReview] = useState(0);
    const [reviewCount, setReviewCount] = useState(0);
    const [lazyLoad, setLazyLoad] = useState(true);


    useEffect(() => {
        // lazyLoader(window, () => {
        //     setLazyLoad(true)
        // })
        if (_.isEmpty(avgReview) && lazyLoad) {
            feefo((review) => {
                if (review) {
                    setAvgReview(review.rating.rating)
                    setReviewCount(review.rating.service.count)
                }
            })
        }
        if (_.isEmpty(reviews) && lazyLoad) {
            allFeefo((data) => {
                if (data) { 
                   var filterData =  _.find(data.reviews, function(o) { return o.service.rating.rating >= 4; }); 
                   console.log(data.reviews)
                    setReviews(filterData)
                }
            })
        }
    })
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    className="reviews"
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                >
                    <Container>
                        <Row>
                            <motion.div className="reviews-img img-zoom d-none d-lg-block" variants={fadeInFromRight}>
                                {lazyLoad &&
                                    <img src={props.Reviews_Background_Image?.url} alt={props.Reviews_Background_Image?.alternativeText} />
                                }
                            </motion.div>
                            <Col lg="6">
                                {reviews &&
                                    <motion.div className="reviews-info" variants={contentItemText}>
                                        <h1>  {reviews.service.title}</h1>
                                        <ul className="stars-icon">
                                            {
                                                reviews.service?.rating?.rating &&
                                                <>{
                                                    [...Array(reviews.service?.rating?.rating).keys()].map((value) => {
                                                        return (<li><i className="icon-stars"></i></li>)
                                                    })
                                                }
                                                </>
                                            }
                                        </ul>
                                        <p>
                                            <ReactReadMoreReadLess
                                                charLimit={60}
                                                readMoreText={"Read more"}
                                                readLessText={"Read less"}
                                                readMoreClassName="read-more-less--more"
                                                readLessClassName="read-more-less--less"
                                            >
                                                {reviews.service.review}
                                            </ReactReadMoreReadLess>
                                        </p>

                                        <div className="reviews-text">
                                            <strong>{reviews.customer?.display_name}</strong>
                                            <span>
                                                {moment(reviews.last_updated_date).fromNow()}
                                            </span>

                                        </div>

                                        <div className="reviews-wrapper">
                                            <Link href="#" className="feefo-brand">
                                                <img src={feefologo} alt="Feefologo" />
                                            </Link>
                                            <span className="rating"><strong> {avgReview}/5</strong> Rating based on  <Link to={`/about/reviews`} className="btn-review">{reviewCount} verified reviews</Link></span>

                                        </div>

                                    </motion.div>
                                }
                            </Col>
                        </Row>
                    </Container>
                </motion.section>
            )}
        </InView>
    )
}
export default Foundation